import { defineStore } from "pinia";
import { ref, computed } from "vue";
import { keys } from "@utils/toolBox";
import useMyFetch from "@stores/useMyFetch";
import handleError from "@composables/handleError";

export const useContactAttributesStore = defineStore("contactAttributes", () => {
  const contactAttributes = ref({});

  const mapToLabelValue = (items) =>
    items?.map((item) => ({ label: item, value: item })).sort((a, b) => a.label.localeCompare(b.label)) || [];
  const getOpenContactAttributeOptions = computed(() => mapToLabelValue(contactAttributes.value.open));
  const getSingleContactAttributeOptions = computed(() => mapToLabelValue(keys(contactAttributes.value.single)));

  const fetchAttributes = async (token) => {
    try {
      const { response, data } = await useMyFetch(`surveys/${token}/brevo/contact_attributes`).json();

      if (response.value.ok) contactAttributes.value = data.value;
    } catch (err) {
      handleError(err);
    }
  };

  return {
    contactAttributes,
    getOpenContactAttributeOptions,
    getSingleContactAttributeOptions,
    fetchAttributes,
  };
});
